import { getSourceIdForUserIdentity } from 'owa-account-source-list';
import { removeAccountById } from 'owa-account-source-list-store';
import { logUsage } from 'owa-analytics';

// Removes the connected account identified by the userIdentit from the source list
export function removeConnectedAccount(userIdentity: string) {
    const sourceId = getSourceIdForUserIdentity(userIdentity);
    if (sourceId) {
        removeAccountById(sourceId);
    }

    const accountFound = sourceId != '';
    logUsage('removeConnectedAccountFromAccountSourceList', {
        accountFound: accountFound,
    });
}
